import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

export function Header() {
	return (
		<Row justify="center">
			<Col span={24} style={{ textAlign: 'center' }}>
				<S.Title>{I18n.get('ROI Calculator')}</S.Title>
			</Col>
		</Row>
	);
}
